import { useState } from 'react';

import {
  DropdownOption,
  Heading,
  Input,
  RyeconMagnifyingGlass,
} from '@dbt-labs/sourdough';

import { useAccountLevelSearchResults } from '@/hooks/useFuzzySearch';
import { INITIAL_PAGE_SIZE } from '../project/resource/components/ResourceFilterTable';
import { MeshProjectTable, ProjectEntry } from './MeshProjectTable';

interface ProjectsSectionProps {
  allProjects: ProjectEntry[];
  isLoadingProjects: boolean;
}

export const ProjectsSection = ({
  allProjects,
  isLoadingProjects,
}: ProjectsSectionProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const pageSize = INITIAL_PAGE_SIZE;
  const [currentPage, setCurrentPage] = useState(0);

  const projectsQuery = useAccountLevelSearchResults<ProjectEntry>({
    query: searchQuery,
    nodes: allProjects || [],
    pageSize: pageSize,
    currentPage: currentPage,
    paginationType: 'pageBased',
  });

  const pageOptions: DropdownOption[] = [
    { label: '5 Rows', value: 5 },
    { label: '10 Rows', value: 10 },
    { label: '25 Rows', value: 25 },
    { label: '50 Rows', value: 50 },
  ];

  return (
    <div className="mt-4 flex flex-col space-y-4">
      <Heading size="4">Find a project</Heading>
      <Input
        name="project-search"
        label="Find a project"
        labelIsHidden
        isEdit
        startIcon={{ ryecon: RyeconMagnifyingGlass }}
        placeholder="Search for a project"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={`my-1 w-full max-w-md flex-1 px-1`}
        testId="project-search-input"
      />
      <MeshProjectTable
        paginationType="pageBased"
        allProjects={projectsQuery.data as ProjectEntry[]}
        pageOptions={pageOptions}
        pageSize={pageSize}
        isLoading={isLoadingProjects}
        hasMoreResults={projectsQuery.hasMoreResults}
        fetchMore={projectsQuery.fetchMore}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalCount={projectsQuery.totalCount}
        totalPages={projectsQuery.totalPages}
      />
    </div>
  );
};
